import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import {
  getActivityList,
} from '../../../../../../general_redux/activities/actions';

import { useWindowSize } from '../../../../../../common/functions/utils';
import Loading from '../../../../../../components/loading';
import Table from '../../../Channel/Components/Tables/Table';
import { TActivityEvent, TActionButtons } from './components';
import ReservationCreatedModal from '../Modals/ReservationCreatedModal/ReservationCreatedModal';
import ReservationUpdatedModal from '../Modals/ReservationUpdatedModal/ReservationUpdatedModal';
import ReservationRequestModal from '../Modals/ReservationRequestModal/ReservationRequestModal';
import ReservationCancelledModal from '../Modals/ReservationCancelledModal/ReservationCancelledModal';
import ReservationNotFoundModal from '../Modals/ReservationNotFoundModal/ReservationNotFoundModal';
import RentalNotFoundModal from '../Modals/RentalNotFoundModal/RentalNotFoundModal';
import GuestModifiedModal from '../Modals/GuestModifiedModal/GuestModifiedModal';
import SettingsMismatchModal from '../Modals/SettingsMismatchModal/SettingsMismatchModal';
import OtherEventsModal from '../Modals/OtherEventsModal/OtherEventsModal';
import notificationEventType from '../../../../../../config/data/notificationTypes';

import styles from './ActivityView.module.css';


const ActivityView = (props) => {

  const dispatch = useDispatch();
  const { width } = useWindowSize();

  const activities = useSelector(({ activities }) => activities && activities.activities);
  const actionForGetActivityList = useSelector(({ activities }) => activities && activities.actionForGetActivityList);

  const [activityData, setActivityData] = useState(null);
  const [activityEventModal, setActivityEventModal] = useState(false);

  const cols = (() => {
    let cols = [
      { label: 'Event', key: 'message', component: 'TActivityEvent' },
      { label: 'Date', key: 'createdAt', component: 'TActivityEvent' },
      { label: 'Actions', key: '', component: 'TActionButtons' },
    ];
    if (width < 460) {
      cols = cols.filter(col => col.label !== 'Date');
    }
    return cols;
  })();

  useEffect(() => {
    dispatch(getActivityList());
  }, []);

  const handleView = (data) => {
    setActivityData(data);
    setActivityEventModal(data.type);
  };
  
  return (
    <div>
      <Loading loadingStatus={actionForGetActivityList.loading} />
      <Container fluid>
        {activities.length ? (
          <Row className='justify-content-left'>
            <Col xs={12} md={8} lg={10} xl={6} className='m-0 p-0'>
              <Row className='m-0 p-0 pl-1 mt-1 justify-content-end'>
              {/* <Row className='m-0 p-0 pl-1 mt-3 mb-4 justify-content-end'> */}
                <div className={styles.buttonContainer}>
                </div>
              </Row>
              <Table
                tableName={'activity'}
                cols={cols}
                rows={[...activities].reverse()} // sort by most recent
                handleView={handleView}
                TActivityEvent={TActivityEvent}
                TActionButtons={TActionButtons}
              />
            </Col>
          </Row>
        ) : (
          <Row className='justify-content-left'>
            <p style={{ fontSize: '20px', margin: '10px 0 0 15px' }}>
              No activities available.
            </p>
          </Row>
        )}
      </Container>

      <OtherEventsModal
        mode={'activity'}
        show={
          [
            notificationEventType.NEW_FEATURE_AVAILABLE,
            notificationEventType.OTA_CONNECTION_ERROR,
            notificationEventType.BEEHAZ_ERROR,
            notificationEventType.DOUBLE_BOOKING,
          ].includes(activityEventModal)
        }
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />

      <SettingsMismatchModal
        mode={'activity'}
        show={activityEventModal === notificationEventType.BEEHAZ_SETTINGS_DIFFER_FROM_OTA}
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />
      
      <GuestModifiedModal
        mode={'activity'}
        show={activityEventModal === notificationEventType.CHANGE_OF_GUEST_DETAILS}
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />

      <ReservationCreatedModal
        mode={'activity'}
        show={activityEventModal === notificationEventType.RESERVATION_CREATED}
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />
      <ReservationUpdatedModal
        mode={'activity'}
        show={activityEventModal === notificationEventType.RESERVATION_UPDATED}
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />
      <ReservationRequestModal
        mode={'activity'}
        show={activityEventModal === notificationEventType.RESERVATION_REQUEST}
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />
      <ReservationCancelledModal
        mode={'activity'}
        show={activityEventModal === notificationEventType.RESERVATION_CANCELLED}
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />
      <ReservationNotFoundModal
        mode={'activity'}
        show={
          [
            notificationEventType.RESERVATION_NOT_FOUND_TO_UPDATE_RESERVATION,
            notificationEventType.RESERVATION_NOT_FOUND_TO_DELETE_RESERVATION,
          ].includes(activityEventModal)
        }
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />
      <RentalNotFoundModal
        mode={'activity'}
        show={
          [
            notificationEventType.RENTAL_NOT_FOUND_TO_CREATE_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_UPDATE_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_REQUEST_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_DELETE_RESERVATION,
          ].includes(activityEventModal)
        }
        onHide={() => {
          setActivityEventModal(false);
          setActivityData(null);
        }}
        values={activityData}
      />

    </div>
  );
};

export default ActivityView;